module.exports = __webpack_public_path__ + "media/images/games/35gender/qImg2-f8680a8acc982afadefc1b9dce63719f.png";